import React from 'react'
import SelectField from 'material-ui-legacy/SelectField'
import MenuItem from 'material-ui-legacy/MenuItem'

/*
Props:
- trueLabel: true option (default: 'Yes')
- falseLabel: false option (default: 'No')
- floatingLabelText, value, onChange etc.: passed down to <SelectField>
*/
const BooleanSelect = (props) => {
  const {
    trueLabel,
    falseLabel,
    value
  } = props

  const adjustedProps = Object.assign({}, props)
  delete adjustedProps.trueLabel
  delete adjustedProps.falseLabel
  delete adjustedProps.value

  return (
    <SelectField
      value={value}
      {...adjustedProps}
    >
      <MenuItem value={true} primaryText={trueLabel || 'Yes'} />
      <MenuItem value={false} primaryText={falseLabel || 'No'} />
    </SelectField>
  )
}

export default BooleanSelect


// WEBPACK FOOTER //
// ./src/components/UI/BooleanSelect.jsx